/** Dome Events branding — never reuse NCG / Facilit8 copy or assets. */
export const brand = {
  org: 'The Dome Namibia',
  product: 'Dome Events',
  productFull: 'Dome Events & Conferencing',
  short: 'Dome Events',
  /** Hostname placeholder until operator confirms DNS */
  hostnameTbd: 'events.thedomenamibia.com',
  prefix: {
    table: 'domeec_',
    bucket: 'dome_events_',
    secret: 'DOMEEC_',
    cookie: 'domeec_session',
  },
} as const;

export const independenceRules = [
  'Not a Facilit8 tenant — no shared auth, billing, data, or deploy pipelines.',
  'Never touch Facilit8 or NCG prefixes (ncgec_*, etc.).',
  'Own Cloudflare Pages project: dome-events-conferencing on The Dome account.',
  'Own Supabase project (Dome-only) with domeec_* tables (buckets: dome_events_*).',
] as const;
